import React, { useEffect }  from "react";
import { useLocation } from "react-router-dom";
import $ from 'jquery';

// 取得視窗比例變化
var sizeVal = 1,
  widthSpan = [500, 750, 1600],
  widthTol = [0.8, 0.9, 1.0],
  tolerance = window.matchMedia('(max-width: 425px)').matches ? 180 : 100; // $(window).width() < 425px ==> true

function pushAndSort(newVal, array) {
  var sortedArr = [].concat(array);
  sortedArr.push(newVal);
  return sortedArr.sort((a, b) => a - b);
}

function calcSize() {
  var indexPos = pushAndSort(window.innerWidth, widthSpan).indexOf(window.innerWidth),
  widthSpanIdx = indexPos >= widthSpan.length ? 2 : indexPos,
  root = document.querySelector(':root');
  sizeVal = (window.innerWidth / widthSpan[widthSpanIdx]).toFixed(2) * widthTol[widthSpanIdx];
  sizeVal = sizeVal > 1 ? 1 : sizeVal;
  root.style.setProperty('--size', sizeVal.toFixed(2));
  tolerance = $('header.header').height();
  root.style.setProperty('--header', tolerance);
};

// DOM載入、捲動、視窗改變大小時取得比例變化
['DOMContentLoaded', 'resize', 'scroll'].forEach(function(eventHandler) {
  window.addEventListener(eventHandler, calcSize, false);
});

function Lullabobby11205() {
	let location = useLocation();
  useEffect(() => {
		// 貼心叮嚀開關
    $(".notice-btn").click(function (e) {
      $(this).toggleClass("active");
      $(this).parents('.boundary').find('.notice-content').slideToggle();
    });
  }, [])
  
  useEffect(() => {
    // 主選單按鈕的點擊捲動
    // $('.scrollBtn').click(function (e) {
    //   e.preventDefault();
    //   var target = $(this).attr('href');
    //   var targetPos = $(target).offset().top - tolerance;
    //   if (target === '#c' && $('.notice-content').is(':hidden')) {
    //     $('.notice-btn').click();
    //   }

    //   $('html, body').animate({
    //     scrollTop: targetPos
    //   }, 1000);
    // });

    // 網頁捲動時主選單按鈕之 active 狀態
    $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
      // var windowHeight = $(window).height();
      $('.scrollBtn').each(function () {
        var target = $(this).attr('href');
        var targetPos = $(target).offset().top - 82;
        var targetHeight = $(target).outerHeight();
        if (targetPos - 1 <= scrollPos && (targetPos + targetHeight) > scrollPos) {
          $('.scrollBtn').removeClass('active')
          $(this).addClass('active');
        } else {
          $(this).removeClass('active')
        }
      });
    });

    // 網頁版捲動時menu box固定
    $(window).scroll(function () {
      if ($(window).width() > 1200){
        if ($(this).scrollTop() > $('.kv').height() + 82) {
          $('.menu-box').css("position", "fixed");
        } else {
          $('.menu-box').css("position", "sticky");
        }
      }      
    });
	}, [location])

	return (
		<div className="lullabobby_wrapper">
      <div className="kv">
        <img src={require("../../image/lullabobby/kv.jpg").default} className="pc" alt="" />
        <img src={require("../../image/lullabobby/kv-m.jpg").default} className="mobile" alt="" />
      </div>
      <div className="menu-box">
        <div className="left-heart"></div>
        <div className="menu">
          <ul>
            <li>
              <div className="scrollBtnBox">
                <a href="#a" className="scrollBtn">
                  <img className="normal" src={require("../../image/lullabobby/m1.svg").default} alt="戀i進行式字體" />
                  <img className="invert" src={require("../../image/lullabobby/m1-h.svg").default} alt="戀i進行式字體反白" />
                  <span>戀i進行式</span>
                </a>
              </div>
            </li>
            <li>
              <div className="scrollBtnBox">
                <a href="#b" className="scrollBtn">
                  <img className="normal" src={require("../../image/lullabobby/m2.svg").default} alt="戀i速成班字體" />
                  <img className="invert" src={require("../../image/lullabobby/m2-h.svg").default} alt="戀i速成班字體反白" />
                  <span>戀i速成班</span>
                </a>
              </div>
            </li>
            <li>
              <div className="scrollBtnBox">
                <a href="#c" className="scrollBtn">
                  <img className="normal" src={require("../../image/lullabobby/m3.svg").default} alt="戀i愛注意字體" />
                  <img className="invert" src={require("../../image/lullabobby/m3-h.svg").default} alt="戀i愛注意字體反白" />
                  <span>戀i愛注意</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
        {/* .menu */}
        <div className="right-heart"></div>
      </div>
      {/* .menu-box */}
      <div className="part-all">
        <div className="part part01" id="">
          <div className="boundary" id="a">
            <div className="covering lullabobby_c1">
              <a className="learn-more-plans" href="https://ibobby.ai.hinet.net/container/commodity" title="連結至商品優惠方案" target="_blank" rel="noreferrer" >
                <img className="normal" src={require("../../image/lullabobby/link-learn-more.svg").default} alt="" />
                <img className="invert" src={require("../../image/lullabobby/link-learn-more-h.svg").default} alt="" />
              </a>
            </div>
            <img className="pc" src={require("../../image/lullabobby/p1-slice1.png").default} alt="" loading="eager" />
            <img className="mobile" src={require("../../image/lullabobby/p1-slice1-m.png").default} alt="" loading="eager" />
          </div>

          <div className="boundary" id="b">
            <div className="covering lullabobby_c2">
              <a className="learn-more-plans" href="https://member.cht.com.tw/" title="連結至我的服務中心" target="_blank" rel="noreferrer" >
                <img className="normal" src={require("../../image/lullabobby/link-to-register.svg").default} alt="" />
                <img className="invert" src={require("../../image/lullabobby/link-to-register-h.svg").default} alt="" />
              </a>
            </div>

            <div className="covering lullabobby_c3">
              <a className="learn-more-plans" href="https://apps.apple.com/tw/app/i%E5%AF%B6%E8%B2%9D/id1457818636?l=en" title="連結至App Store下載i寶貝App" target="_blank" rel="noreferrer" >
                <span>Download on the App Store</span>
              </a>
            </div>

            <div className="covering lullabobby_c4">
              <a className="learn-more-plans" href="https://play.google.com/store/apps/details?id=com.ibobbyplus" title="連結至Google Play下載i寶貝App" target="_blank" rel="noreferrer" >
                <span>Get it on Google Play</span>
              </a>
            </div>
            <img className="pc" src={require("../../image/lullabobby/p1-slice2.png").default} alt="" loading="lazy" />
            <img className="mobile" src={require("../../image/lullabobby/p1-slice2-m.png").default} alt="" loading="lazy" />
          </div>
        </div>
        <div className="part lullabobby_part03">
          <div className="boundary" id="c">
            <h2>
              <img className="pc" src={require("../../image/lullabobby/p1-slice3.png").default} alt="" loading="lazy" />
              <img className="mobile" src={require("../../image/lullabobby/p1-slice3-m.png").default} alt="" loading="lazy" />
            </h2>
          </div>
          <div className="boundary lullabobby_notice">
            <div className="notice-btn">
              i寶貝「有控，來談個戀i吧」活動注意事項<span></span>
            </div>
            <div className="notice-content">
              <p>
                歡迎您參與i寶貝『有控，來談個戀i吧』（以下簡稱本活動），為保障您的權益，在參加本活動前，請先詳細閱讀本活動注意事項所有內容，當您開始進行本活動之各項內容後，即表示您完全明白、同意及接受本活動注意事項的內容。如果您無法遵守本活動注意事項內容，或不同意本活動注意事項內容時，請您立即停止參與本活動。為確保您的權益，建議您經常確認本活動注意事項之最新條文內容。
              </p>
              <ul>
                <li>
                  參加者一旦參加此活動，將視為同意授權主辦單位、贈獎執行單位蒐集、處理與利用參加者參加活動時所提供之個人資料。資料利用期間為本活動期間及本活動辦理完畢為止，利用地區為中華民國台灣地區(台澎金馬)。參加本活動所提供之個人資料，視同同意本公司做為抽獎、得獎公告、贈品發送之用，並同意本活動本公司進行中獎相關聯繫事宜。如因參加本活動所提供之個人資料不完整或不正確，致影響參與抽獎、得獎或領獎等權利者，概由參加者(中獎者)自行負責且不得求償。中獎者若因資格不符、自動放棄或未遵守本活動規定，致遭取消領獎資格時，不得以任何理由求償。
                </li>
                <li>
                  填寫產品申請書時，若沒填寫行動電話，以至於系統作業上無法撈取，則無法參與本活動（抽獎與贈送流量券），視同放棄。
                </li>

                <li>
                  因填寫資料不全、有誤而導致贈品遭冒領者，恕不另行補發。經查資料有造假，視同放棄得獎權利，已領獎者須繳回已領取之獎項，並應負相關法律責任。如中獎者喪失領獎資格或逾期未領取獎項，抑或於獎品發放後發生如遺失、盜領或損毀情況，恕不補發或更換獎品。
                </li>
                <li>
                  如有任何因手機、電腦、網路、電話、技術或不可歸責於活動本公司之事由，而使參加者登錄之資料有延遲、延遲、遺失、錯誤、無法辨識或毀損之情況，本公司不負任何法律責任，參加者與中獎者亦不得因此異議。
                </li>
                <li>
                  本活動之抽獎、中獎或兌獎記錄均以本公司電腦系統紀錄為準。本公司有權檢視各項交易及抽獎紀錄，若參加人有違反活動注意事項之行為或涉及不正當得利及非法行為，本公司將公告排除其參與活動及兌領資格。
                </li>
                <li>
                  參與活動以中華電信會員帳號為憑，所有參加者保證中華電信會員中心之資料為正確且完整之個人資料，並與公告或領獎時所提出之個人資料相符。會員中心之資料未完整、正確者及領獎逾期者視為自動放棄得獎資格，主辦單位將不予另行通知。
                </li>
                <li>
                  隱私權聲明：本公司蒐集、處理、利用會員參加本抽獎活動所需之個人資料（含姓名、電話、Email、地址等），將基於本活動抽獎、中獎公告與通知、獎品發送。使用期間僅限蒐集日起至活動獎項贈送完成日止，利用地區為台灣。依據個人資料保護法第
                  3
                  條規定，參加者可向本公司行使之權利包括：查詢、補充、更正及刪除等。
                </li>
                <li>
                  依中華民國稅法及財政部規定，因申報各類所得之需，若為中華民國境內居住者，中獎金額超過NT$1,000元（含）者，須繳交身分證影本，超過NT$20,000元(含)以上者，將由主(協)辦單位代扣10%機會中獎稅金後，始可領獎，獎品價值以本活動公告為準。
                </li>
                <li>
                  若為中華民國境內居住者，財政部臺北國稅局實施「憑單無紙化」，自2014年起所得稅各式憑單符合一定情形者，憑單填發單位如期向國稅局辦理憑單申報後，原則上免寄發憑單給納稅義務人。另得獎者需於2024年5月底前完成申報，得獎者若不願意配合，則視為自動棄權，不具得獎資格。（依中華民國稅法規定，中華民國境內居住者年度累計機會中獎得獎價值NT$1,000元（含）以上者，年度報稅時將計入個人所得；中獎價值累計NT$1,000元（含）以上者而未滿20歲之中獎人，視同父母或監護人中獎，由父母或監護人代為領獎，並請附上得獎者及其代領人關係證明影本，年度報稅時將計入父母或監護人個人所得）。
                </li>
                <li>
                  本活動之兌獎權利、得獎資格及(或)所有獎品不負責後續維修、保固之責任、亦不得要求指定顏色、型號、更改獎項或其他類型贈品，亦不得轉換、轉讓或折換現金。獎項以公佈於本網站上的資料為準，如遇不可抗力之因素，主辦單位保留更換其他等值獎項之權利，且無需事前通知或公布。
                </li>
                <li>
                  本公司保有修改活動內容及辦法之權利，如有異動，以活動網頁公告為主。若遇不可抗力之特殊原因無法執行活動時，本公司有權決定取消、終止、修改或暫停。
                </li>
                <li>
                  參加者須自行負擔因參加本活動所發生之一切費用，包括但不限於郵資及可能之稅負。
                </li>
                <li>
                  主辦單位對於此獎項或使用此獎項時所造成的任何損失、傷害、個人意外或死亡概不負責。
                </li>
                <li>
                  上述條款之準據法為中華民國法律，若因本活動而發生任何爭議時，應以台灣台北地方法院為第一審管轄法院。
                </li>
              </ul>
              <p className="sub-head">【勁爽加量包使用注意事項】</p>
              <ul>
                <li>
                  本活動贈送之「勁爽加量包」1GB行動上網量，以簡訊形式發送流量兌換序號予符合資格之客戶。請妥善保存流量序號簡訊，遺失恕不補發。上述贈品不得要求折換成現金或有價商品。
                </li>
                <li>
                  「勁爽加量包」兌換序號之效期依簡訊載明之日期為準，逾期失效。限中華電信4G及5G月租型門號，至勁爽加量包網頁或中華電信APP兌換，亦可轉贈予其他中華電信4G或5G月租型門號用戶使用。預付卡不適用。
                </li>
                <li>
                  「勁爽加量包」兌換條件：最後一筆上網量使用達70%時（收到用量通知），方可兌換上網量。兌換成功之實際生效時點以系統開通時間為準，開通時將以簡訊通知；兌換成功後將無法更改、異動、取消及折換現金。兌換之上網量可使用到次一計費週期結束，網速將依兌換者當時使用門號之網速方案提供。
                </li>
                <li>
                  「勁爽加量包」係提供客戶於國內透過本公司行動網路瀏覽Hami網頁及網際網路，若使用國際漫遊上網，通信費需另依國際漫遊費率計收。
                </li>
                <li>
                  「勁爽加量包」使用規則與說明詳
                  <a href="https://www.cht.com.tw/home/consumer/mobservice/basic/803" title="連結至勁爽加量包網頁" target="_blank" rel="noreferrer" >勁爽加量包網頁</a>說明。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <script type="text/javascript" src="js/jquery.js"></script>
      <script type="text/javascript" src="homepage/js/sal/sal.js"></script>
      <script> sal(); </script>
      <script type="text/javascript" src="homepage/js/script.js"></script>
      <script type="text/javascript" src="js/index.js"></script>
    </div>
	)
}

export default Lullabobby11205;